// formC_SeguimientoObra.jsx
import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import InfoButtonWithPopover from "./InfoButtonWithPopover";
import { useFormContext } from "../context/FormContext";
import { Input, Label, Button, Select_simple } from "../components/ui";
import { optionsEncargadoRendicion, optionsOrganismoEncargado } from '../datos/options';
import { PAGO_MEJORAS_INICIAL } from "../utils/initialStates";
// Función para formatear números en formato argentino (1.234.567,89)
const formatNumberArgentino = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const num = parseFloat(value);
    if (isNaN(num)) return '';
    return num.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// Función para parsear el input formateado de vuelta a número
const parseNumberArgentino = (value) => {
    if (!value) return '';
    // Remover puntos (separadores de miles) y convertir coma a punto decimal
    const cleaned = value.replace(/\./g, '').replace(',', '.');
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? '' : parsed;
};

// Opciones de porcentaje para los pagos
const OPCIONES_PORCENTAJE = {
    ANTICIPO: [
        { value: '30', label: '30%' },
        { value: '50', label: '50%' }
    ],
    SEGUNDO_PAGO_50: [  // Opción para cuando el anticipo es 50%
        { value: '50', label: '50%' }
    ],
    SEGUNDO_PAGO_30: [  // Opción para cuando el anticipo es 30%
        { value: '35', label: '35%' }
    ],
    TERCER_PAGO: [  // Solo se usa cuando el anticipo es 30%
        { value: '35', label: '35%' }
    ],
    ADENDA: [  // Opción para pagos de adenda
        { value: '100', label: '100%' }
    ]
};

const FormC_SeguimientoObra = () => {  
    const { formA, formC, updateField, updateFormC } = useFormContext();
    const { datosGenerales, array_obras_expediente } = formA;
    const { seguimientoObra, arrayPagosMejoras, arrayPagosMicrocreditos, arrayPagosProyectos } = formC;

    // Obtener valores directamente del contexto
    const {
        encargadoRendicion,
        organismoEncargado,
        empresaContratista,
        fechaInicioObra,
        fechaFinObra,
        observaciones,
        
    } = seguimientoObra;

    //console.log("LEON seguimientoObra", seguimientoObra)

    //// 1. Usar estado local para manejar los pagos mejoras
    // Para mejoras, no usamos estado local, editamos directamente en contexto
    // const [arrayPagosMejorasLocal, setArrayPagosMejorasLocal] = useState(() => {
    //     const initialData = formC?.arrayPagosMejoras;
    //     //console.log("GATO initialData ", initialData)
    //     return Array.isArray(initialData) && initialData.length > 0
    //         ? initialData
    //         : [
    //             { tipo_pago: "total", monto: '', fecha_pago: null, nro_instruccion: '', fecha_certificacion: null },
    //             { tipo_pago: "adenda", total_adenda: '', monto: '', fecha_pago: null, nro_instruccion: '', fecha_certificacion: null }
    //         ];
    // });

    // Para microcreditos, no usamos estado local, editamos directamente en contexto
    // const [arrayPagosMicrocreditosLocal, setArrayPagosMicrocreditosLocal] = useState(() => {
    //     const initialData = formC?.arrayPagosMicrocreditos;
    //     return Array.isArray(initialData) && initialData.length > 0
    //         ? initialData
    //         : [...PAGO_MICROCREDITOS_INICIAL];
    // });

    // Para proyectos, no usamos estado local, editamos directamente en contexto

    // Funciones de actualización que actualizan el contexto
    const setEncargadoRendicionValue = (value) => {
        updateField('formC', 'seguimientoObra', 'encargadoRendicion', value);
    };

    const setOrganismoEncargadoValue = (value) => {
        updateField('formC', 'seguimientoObra', 'organismoEncargado', value);
    };

    const setEmpresaContratistaValue = (value) => {
        updateField('formC', 'seguimientoObra', 'empresaContratista', value);
    };

    const setFechaInicioObraValue = (value) => {
        updateField('formC', 'seguimientoObra', 'fechaInicioObra', value);
    };

    const setFechaFinObraValue = (value) => {
        updateField('formC', 'seguimientoObra', 'fechaFinObra', value);
    };

    const setObservacionesValue = (value) => {
        updateField('formC', 'seguimientoObra', 'observaciones', value);
        setTextInput1(value); // Actualizar el estado local para el contador de caracteres
    };    

    // Usar los valores del contexto para los arrays de pagos, con valor por defecto de array vacío
    const arrayPagosMejorasValue = arrayPagosMejoras ?? [];
    const arrayPagosMicrocreditosValue = arrayPagosMicrocreditos ?? [];
    
    const areaResponsable = datosGenerales.area_responsable;
    
    // Estado local para el monto de la adenda
    const [totalAdenda, setTotalAdenda] = useState(0);

     //ESTADOS LOCAL - para contador de caracteres
     const [textInput1, setTextInput1] = useState(''); //input observ_seguimiento_obra
    
    // Efecto para actualizar el monto de la adenda cuando cambia array_obras_expediente
    useEffect(() => {
        if (array_obras_expediente?.some(exp => exp.objeto_o === 'Adenda' && exp.monto_adenda)) {
            const adenda = array_obras_expediente.find(exp => exp.objeto_o === 'Adenda');
            setTotalAdenda(adenda?.monto_adenda || 0);
        } else {
            setTotalAdenda(0);
        }
    }, [array_obras_expediente]);   
    

    //dentro de arrayPagosMejoras, buscar el objeto con tipo_pago = 'adenda' y actualizar el valor de total_adenda con el valor de totalAdenda
    /*useEffect(() => {
        // Convierte totalAdenda a número (maneja strings numéricos)
        const numericTotalAdenda = Number(totalAdenda);

        // Solo actualizar si es un número válido (evita NaN o valores no numéricos)
        if (isNaN(numericTotalAdenda)) return;

        console.log("typeof totalAdenda original", typeof totalAdenda);
        console.log("numericTotalAdenda", numericTotalAdenda);
        if(areaResponsable === "ÁREA DE PROYECTOS"){
            const updatedArray = arrayPagosProyectosValue.map((pago, index) => {
                // Si el pago es de tipo 'adenda', actualiza total_adenda; de lo contrario, déjalo igual
                if (pago.tipo_pago === 'adenda') {
                    return { ...pago, total_adenda: totalAdenda };  // Crea un nuevo objeto (inmutabilidad)
                }
                return pago;  // Mantén el resto igual
            });

            //setArrayPagosProyectos(updatedArray);
            updateField("seguimientoObra", "arrayPagosProyectos", updatedArray);
        } else if(areaResponsable === "ÁREA DE MEJORAS"){
            const updatedArray = arrayPagosMejorasValue.map((pago, index) => {
                // Si el pago es de tipo 'adenda', actualiza total_adenda; de lo contrario, déjalo igual
                if (pago.tipo_pago === 'adenda') {
                    return { ...pago, total_adenda: totalAdenda };  // Crea un nuevo objeto (inmutabilidad)
                }
                return pago;  // Mantén el resto igual
            });
            
            updateField("seguimientoObra", "arrayPagosMejoras", updatedArray);
        } else if(areaResponsable === "ÁREA DE MICROCREDITOS"){
            const updatedArray = arrayPagosMicrocreditosValue.map((pago, index) => {
                // Si el pago es de tipo 'adenda', actualiza total_adenda; de lo contrario, déjalo igual
                if (pago.tipo_pago === 'adenda') {
                    return { ...pago, total_adenda: totalAdenda };  // Crea un nuevo objeto (inmutabilidad)
                }
                return pago;  // Mantén el resto igual
            });
            
            updateField("seguimientoObra", "arrayPagosMicrocreditos", updatedArray);
        }
    }, [totalAdenda]);
    */
    

    // Efecto para sincronizar monto_obra de datosGenerales con montoObra de seguimientoObra
    useEffect(() => {
        if (datosGenerales.monto_obra !== undefined &&
            datosGenerales.monto_obra !== seguimientoObra.montoObra) {
            updateField('formC', 'seguimientoObra', 'montoObra', datosGenerales.monto_obra);
        }
    }, [datosGenerales.monto_obra, seguimientoObra.montoObra, updateField]);

    //contador de caracteres #19NOV25:   
    const contadorCaracteresRestantes = (limite, texto) => {
        // Si el texto es null o undefined, usar string vacío
        const longitud = texto ? texto.length : 0;
        // Asegurarse de que el límite sea un número válido
        const limiteValido = limite || 0;
        // Calcular caracteres restantes, asegurando que no sea negativo
        return Math.max(0, limiteValido - longitud);
    }    


    // Función para actualizar los estados de habilitación basados en el anticipo seleccionado
    const actualizarPorcentajes = (pagos) => {
        // Validar que pagos sea un array
        if (!Array.isArray(pagos)) return [];
        
        // Verificar que los valores sean números válidos
        const esNumeroValido = (valor) => !isNaN(parseFloat(valor)) && isFinite(valor);
        
        const anticipo = parseFloat(pagos[0]?.porc_pago || 0);
        const montoConveniado = parseFloat(datosGenerales.monto_obra || 0);
    
        // Obtener valores válidos de los pagos
        const segundoPagoValido = esNumeroValido(pagos[1]?.porc_pago) ? parseFloat(pagos[1].porc_pago) : 0;
        const tercerPagoValido = esNumeroValido(pagos[2]?.porc_pago) ? parseFloat(pagos[2].porc_pago) : 0;
    
        // Determinar si adenda debe estar habilitada
        const debeHabilitarAdenda = (
            (anticipo === 50 && segundoPagoValido === 50) ||
            (anticipo === 30 && (segundoPagoValido + tercerPagoValido) === 70)
        );
    
        // Depuración
        console.log('Estado de habilitación de adenda:', {
            anticipo,
            segundoPago: pagos[1]?.porc_pago,
            tercerPago: pagos[2]?.porc_pago,
            segundoPagoValido,
            tercerPagoValido,
            debeHabilitarAdenda
        });
    
        // Si no hay anticipo, deshabilitar todo excepto el primer pago
        if (!anticipo) {
            return pagos.map((pago, i) => pago ? {
                ...pago,
                disabled: i !== 0 || pago.tipo_pago === 'adenda',
                monto: '0',
                porc_pago: ''
            } : null).filter(Boolean);
        }
    
        // Función auxiliar para verificar si un pago está completo
        const pagoCompleto = (pago) => pago?.porc_pago && pago.porc_pago !== '';
    
        // Mapear pagos y actualizar estado
        return pagos.map((pago, i) => {
            // Si el pago no existe, retornar null (será filtrado)
            if (!pago) return null;
    
            // Manejar pago de adenda
            if (pago.tipo_pago === 'adenda') {
                return {
                    ...pago,
                    disabled: !debeHabilitarAdenda,
                    monto: debeHabilitarAdenda ? (pago.monto || '0') : '0',
                    porc_pago: debeHabilitarAdenda ? (pago.porc_pago || '') : ''
                };
            }
    
            // Lógica para pagos regulares
            if (anticipo === 50) {
                if (i === 0) { // Anticipo 50%
                    return {
                        ...pago,
                        disabled: false,
                        monto: (montoConveniado * 0.50).toFixed(2),
                        porc_pago: '50'
                    };
                }
                if (i === 1) { // Segundo pago 50%
                    return {
                        ...pago,
                        disabled: false,
                        monto: pago.porc_pago ? (montoConveniado * parseFloat(pago.porc_pago) / 100).toFixed(2) : '0',
                        porc_pago: pago.porc_pago || ''
                    };
                }
                // Tercer pago deshabilitado para anticipo 50%
                return {
                    ...pago,
                    disabled: true,
                    monto: '0',
                    porc_pago: ''
                };
            }
    
            if (anticipo === 30) {
                if (i === 0) { // Anticipo 30%
                    return {
                        ...pago,
                        disabled: false,
                        monto: (montoConveniado * 0.30).toFixed(2),
                        porc_pago: '30'
                    };
                }
                if (i === 1) { // Segundo pago
                    return {
                        ...pago,
                        disabled: false,
                        monto: pago.porc_pago ? (montoConveniado * parseFloat(pago.porc_pago) / 100).toFixed(2) : '0',
                        porc_pago: pago.porc_pago || ''
                    };
                }
                if (i === 2) { // Tercer pago
                    const segundoPagoCompleto = pagoCompleto(pagos[1]);
                    return {
                        ...pago,
                        disabled: !segundoPagoCompleto,
                        monto: segundoPagoCompleto ? (pago.monto || '0') : '0',
                        porc_pago: segundoPagoCompleto ? (pago.porc_pago || '') : ''
                    };
                }
            }
    
            return pago;
        }).filter(Boolean); // Filtramos cualquier null resultante
    };

    // 4. Modificar los manejadores para usar setArrayPagosMejorasLocal
    const handlePagoChangeLocal = (index, field, value, setter) => {
        console.log("Actualizando pago:", { index, field, value, setter });
        
        setter(prev => {
            // Asegurarse de que prev sea un array
            const prevArray = Array.isArray(prev) ? prev : [];
            const newPago = [...prevArray];
            
            // Asegurarse de que el índice existe
            if (!newPago[index]) {
                newPago[index] = {};
            }
            
            // Crear un nuevo objeto de pago con el campo actualizado
            const updatedPago = {
                ...newPago[index],
                [field]: value
            };
            
            // Si se está actualizando el porcentaje de pago
            if (field === 'porc_pago') {
                if (value === '' || isNaN(value)) {
                    // Si se selecciona 'Seleccione' o valor inválido, limpiar el monto
                    updatedPago.monto = '';
                } else {
                    // Si es un pago de adenda, usar totalAdenda, de lo contrario usar monto_obra
                    const montoBase = prevArray[index]?.tipo_pago === 'adenda' 
                        ? parseFloat(totalAdenda || 0) 
                        : parseFloat(datosGenerales.monto_obra || 0);
                    
                    const porcentaje = parseFloat(value);
                    // Calcular el monto basado en el porcentaje (hasta 2 decimales)
                    const montoCalculado = (montoBase * porcentaje / 100).toFixed(2);
                    updatedPago.monto = montoCalculado;
                }
            }
            
            newPago[index] = updatedPago;
            
            // Si estamos cambiando el porcentaje del anticipo, actualizar los estados
            if (index === 0 && field === 'porc_pago') {
                return actualizarPorcentajes(newPago);
            }
            
            return newPago;
        });  
    };

    // Handler para proyectos, actualiza directamente el contexto
    const handlePagoChangeProyectos = (index, field, value) => {
        console.log("Actualizando pago proyectos:", { index, field, value });
        
        const currentArray = Array.isArray(formC.arrayPagosProyectos) ? [...formC.arrayPagosProyectos] : [];
        
        // Asegurarse de que el índice existe
        if (!currentArray[index]) {
            currentArray[index] = {};
        }
        
        // Crear un nuevo objeto de pago con el campo actualizado
        const updatedPago = {
            ...currentArray[index],
            [field]: value
        };
        
        // Si se está actualizando el porcentaje de pago
        if (field === 'porc_pago') {
            if (value === '' || isNaN(value)) {
                // Si se selecciona 'Seleccione' o valor inválido, limpiar el monto
                updatedPago.monto = '';
            } else {
                // Si es un pago de adenda, usar totalAdenda, de lo contrario usar monto_obra
                const montoBase = currentArray[index]?.tipo_pago === 'adenda' 
                    ? parseFloat(totalAdenda || 0) 
                    : parseFloat(datosGenerales.monto_obra || 0);
                
                const porcentaje = parseFloat(value);
                // Calcular el monto basado en el porcentaje (hasta 2 decimales)
                const montoCalculado = (montoBase * porcentaje / 100).toFixed(2);
                updatedPago.monto = montoCalculado;
            }
        }
        
        currentArray[index] = updatedPago;
        
        // Si estamos cambiando el porcentaje del anticipo, actualizar los estados
        if (index === 0 && field === 'porc_pago') {
            const updatedArray = actualizarPorcentajes(currentArray);
            updateField('formC', 'arrayPagosProyectos', null, updatedArray);
            return;
        }
        
        // Si estamos deseleccionando el segundo pago (índice 1) y el anticipo es 30%,
        // también debemos limpiar el tercer pago (índice 2)
        if (index === 1 && field === 'porc_pago' && value === '' && 
            currentArray[0]?.porc_pago === '30' && 
            currentArray[2]) {
            currentArray[2] = {
                ...currentArray[2],
                monto: '0',
                porc_pago: ''
            };
        }
        
        updateField('formC', 'arrayPagosProyectos', null, currentArray);
    };

    // Handler para mejoras, actualiza directamente el contexto
    const handlePagoChangeMejoras = (index, field, value) => {
        console.log("Actualizando pago mejoras:", { index, field, value });
        
        const currentArray = Array.isArray(formC.arrayPagosMejoras) ? [...formC.arrayPagosMejoras] : [];
        
        // Asegurarse de que el índice existe
        if (!currentArray[index]) {
            currentArray[index] = {};
        }
        
        // Actualizar el campo
        if (field === 'monto' || field === 'total_adenda') {
            // Convertir a número si es numérico
            currentArray[index][field] = value === '' ? '' : Number(value);
        } else if (field === 'fecha_pago' || field === 'fecha_certificacion') {
            // Manejar fechas
            currentArray[index][field] = value ? new Date(value) : null;
        } else {
            // Para otros campos, mantener el valor tal cual
            currentArray[index][field] = value;
        }
        
        updateField('formC', 'arrayPagosMejoras', null, currentArray);
    };

    // Handler para microcreditos, actualiza directamente el contexto
    const handlePagoChangeMicrocreditos = (index, field, value) => {
        console.log("Actualizando pago microcreditos:", { index, field, value });
        
        const currentArray = Array.isArray(formC.arrayPagosMicrocreditos) ? [...formC.arrayPagosMicrocreditos] : [];
        
        // Asegurarse de que el índice existe
        if (!currentArray[index]) {
            currentArray[index] = {};
        }
        
        // Actualizar el campo
        if (field === 'monto' || field === 'porc_avance_obra') {
            currentArray[index][field] = value === '' ? '' : Number(value);
        } else if (field === 'fecha_pago' || field === 'fecha_certificacion') {
            currentArray[index][field] = value ? new Date(value) : null;
        } else {
            currentArray[index][field] = value;
        }
        
        updateField('formC', 'arrayPagosMicrocreditos', null, currentArray);
    };

    // Función genérica para manejar los cambios en los arrays de pagos
    const handlePagoChange = (index, field, value, setter, array) => {
        // Crear una copia profunda del array
        const updatedArray = JSON.parse(JSON.stringify(array));
        
        // Asegurarse de que el array principal tenga elementos
        if (updatedArray.length === 0) {
            updatedArray.push([]);
        }
        
        // Asegurarse de que el índice exista en el array interno
        if (!updatedArray[0][index]) {
            updatedArray[0][index] = {};
        }
        
        // Actualizar el campo específico
        if (field === 'monto' || field === 'porc_avance_obra') {
            // Convertir a número si es un campo numérico
            updatedArray[0][index][field] = value === '' ? '' : Number(value);
        } else if (field === 'fecha_pago' || field === 'fecha_certificacion') {
            // Manejar fechas
            updatedArray[0][index][field] = value ? new Date(value) : null;
        } else {
            // Para otros campos, mantener el valor tal cual
            updatedArray[0][index][field] = value;
        }
        
        console.log('Actualizando pago:', { index, field, value, updatedArray });
        
        // Llamar a la función de actualización
        setter(updatedArray);
    };

    /*const handlePagoChange = (tipoPago, index, field, value) => {
        // Get the current array based on the payment type
        const arrayName = `arrayPagos${tipoPago}`;
        const currentArray = [...(formC.seguimientoObra[arrayName] || [])];

        // Ensure the index exists
        if (index < 0 || index >= currentArray.length) {
            console.error(`Invalid index ${index} for ${arrayName}`);
            return;
        }

        // Create a copy of the payment object to update
        const updatedPayment = { ...currentArray[index] };

        // Handle different field types
        if (field === 'monto' || field === 'porc_avance_obra' || field === 'porc_pagado') {
            // Convert to number for numeric fields
            updatedPayment[field] = value === '' ? '' : Number(value);
        } else if (field === 'fecha_pago' || field === 'fecha_certificacion') {
            // Handle date fields
            updatedPayment[field] = value;
        } else {
            // For other fields, keep the value as is
            updatedPayment[field] = value;
        }

        // Create a new array with the updated payment
        const updatedArray = [...currentArray];
        updatedArray[index] = updatedPayment;

        // Update the formC state
        updateFormC({
            seguimientoObra: {
                ...formC.seguimientoObra,
                [arrayName]: updatedArray
            }
        });

        console.log(`Updated ${arrayName}[${index}].${field}:`, value);
    };*/

    const inputClasses = `w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500
                          dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100 dark:placeholder-gray-400`;
    const headerClasses = `py-2 px-4 font-semibold text-left border-b border-gray-300
                           dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600`;
    const rowClasses = `py-2 px-4 border-b border-gray-200 dark:border-gray-700`;

    // funcion axiliar para el rendereizado en el documento (1-agos-2025)
    const capitalize = (str) => {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    //generar un array de pruebas
    const generarArrayPruebas = () => {
        const arrayPruebas = [];
        for (let i = 0; i < 5; i++) {
            arrayPruebas.push({
                pago: `Pago ${i + 1}`,
                monto: 1000,
                fecha_pago: new Date(),
                nro_instruccion: `Nro. Instrucción ${i + 1}`,
                porc_avance_obra: 10,
                fecha_certificacion: new Date()
            });
        }
        return arrayPruebas;
    }

    const generarArrayPruebasProyectos = () => {
        // Determinar qué array de pagos usar según el área
        let pagos = [];
        let pagosFuente = [];
        
        if (areaResponsable === 'ÁREA DE PROYECTOS') {
            pagosFuente = arrayPagosProyectos;
        } else if (areaResponsable === 'ÁREA DE MEJORAS') {
            pagosFuente = arrayPagosMejoras;
        } else if (areaResponsable === 'ÁREA DE MICROCRÉDITOS') {
            pagosFuente = arrayPagosMicrocreditos;
        }
        
        console.log(`arrayPagos (${areaResponsable}):`, JSON.parse(JSON.stringify(pagosFuente)));
        
        // Manejar el formato del array (puede estar anidado o no)
        if (Array.isArray(pagosFuente) && pagosFuente.length > 0) {
            if (Array.isArray(pagosFuente[0])) {
                pagos = pagosFuente[0]; // Tomar el array interno si está anidado
            } else {
                pagos = pagosFuente; // Ya es un array de pagos
            }
        }
        
        console.log('pagos procesados:', JSON.parse(JSON.stringify(pagos)));
        
        // Filtrar los pagos para omitir 'adenda' si no hay expediente con objeto 'Adenda'
        const pagosFiltrados = pagos.filter(pago => {
            const esAdenda = pago.tipo_pago === 'adenda';
            const tieneExpedienteAdenda = array_obras_expediente?.some(exp => exp.objeto_o === 'Adenda');
            
            // Si es adenda y no tiene expediente, lo filtramos
            if (esAdenda && !tieneExpedienteAdenda) {
                console.log('Omitiendo pago de adenda (PROYECTOS)');
                return false;
            }
            return true;
        });
        
        console.log('pagos filtrados:', JSON.parse(JSON.stringify(pagosFiltrados)));
        
        // Mapear los pagos a la estructura que espera el renderizado
        const pagosMapeados = pagosFiltrados.map((pago, index) => {
            // Si pago no es un objeto, devolver un objeto vacío
            if (typeof pago !== 'object' || pago === null) {
                console.warn('Pago no es un objeto:', pago);
                return {};
            }

            // Determinar el texto del pago basado en el tipo_pago
            let textoPago = '';
            switch(pago.tipo_pago) {
                case 'total':
                    textoPago = 'Total'; 
                    break;
                case 'anticipo': 
                    textoPago = 'Anticipo'; 
                    break;
                case '2do_pago': 
                    textoPago = '2do Pago'; 
                    break;
                case '3er_pago': 
                    textoPago = '3er Pago'; 
                    break;
                case 'adenda': 
                    textoPago = 'Adenda'; 
                    break;
                default: 
                    textoPago = `Pago ${index + 1}`;
            }
            
            // Devolver un nuevo objeto con las propiedades necesarias
            return {
                ...pago,  // Mantener todas las propiedades originales
                tipo_pago: pago.tipo_pago,  // Mantener el valor original de tipo_pago
                tipo_pago_display: textoPago,  // Usar un campo separado para el texto mostrado
                porc_pago: pago.porc_pago || '',//solo si existe
                monto: pago.monto || '',
                nro_instruccion: pago.nro_instruccion || '',
                porc_avance_obra: pago.porc_avance_obra || '',
                fecha_pago: pago.fecha_pago || null,
                fecha_certificacion: pago.fecha_certificacion || null
            };
        });
        
        console.log('pagosMapeados:', pagosMapeados);
        return pagosMapeados;
    }  

    // Renderización condicional del formulario de pagos usando CSS Grid - Versión de depuración
    const renderPagosFormularioNuevo = () => {
        console.log('=== INICIO renderPagosFormularioNuevo ===');
        console.log('areaResponsable:', areaResponsable);
        console.log('array_obras_expediente:', array_obras_expediente);
        console.log('arrayPagosProyectos:', arrayPagosProyectos);
        //console.log('ctxArrayPagosProyectos:', ctxArrayPagosProyectos);

        if (areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS') {
            const pagos = areaResponsable === 'ÁREA DE MEJORAS' ? arrayPagosMejoras : arrayPagosMicrocreditos;
            const handleChange = areaResponsable === 'ÁREA DE MEJORAS' ? handlePagoChangeMejoras : handlePagoChangeMicrocreditos;
            const gridCols = 'grid-cols-5';

            // Verificar si hay algún expediente con objeto_o 'Rendición'
            const tieneRendicion = array_obras_expediente?.some(exp => exp.objeto_o === 'Rendición');
            console.log('Tiene rendición:', tieneRendicion);

            // Si no hay expediente con 'Rendición', mostrar mensaje
            if (!tieneRendicion) {
                return (
                    <div className="mt-4 p-4 bg-red-50 dark:bg-red-900/20 rounded-md border border-red-200 dark:border-red-800">
                        <h3 className="text-lg font-semibold mb-2 dark:text-white">Formulario de Pagos (Nuevo)</h3>
                        <p className="text-red-700 dark:text-red-300">
                            {`⚠️ No se puede mostrar el formulario de pagos porque no hay un expediente con objeto 'Rendición'.`}
                        </p>
                    </div>
                );
            }

            // Usar generarArrayPruebasProyectos para obtener los pagos filtrados
            const pagosFiltrados = generarArrayPruebasProyectos();
            //console.log('Renderizando formulario de pagos para:', areaResponsable);
            //console.log('Pagos a renderizar (filtrados):', pagosFiltrados);

            // Obtener el nombre del área para mostrar en el título
            const getAreaTitle = () => {
                switch(areaResponsable) {
                    case 'ÁREA DE PROYECTOS': return 'PROYECTOS';
                    case 'ÁREA DE MEJORAS': return 'MEJORAS';
                    case 'ÁREA DE MICROCRÉDITOS': return 'MICROCRÉDITOS';
                    default: return '';
                }
            };
            
            return (
                <div className="mt-4 overflow-x-auto">
                    <h3 className="text-lg font-semibold mb-2 dark:text-white">
                        Formulario de Pagos (Nuevo){getAreaTitle() ? ` - ${getAreaTitle()}` : ''}
                    </h3>
                    <div className="w-full">
                        {/* Header */}
                        <div className={`grid ${gridCols} text-sm lg:text-base`}>
                            <div className={headerClasses}>Pago</div>
                            <div className={headerClasses}>Monto</div>
                            <div className={headerClasses}>Fecha de Pago</div>
                            <div className={headerClasses}>Nro. Instrucción</div>
                            <div className={headerClasses}>Fecha Certificación</div>
                        </div>

                        {/* Rows */}
                        {pagosFiltrados.map((pago, index) => {                            
                            console.log('Procesando pago:', pago);
                            
                            // Ya no es necesario el filtro aquí, ya que se hace en generarArrayPruebasProyectos
                            
                            return (
                                <div key={`${pago.tipo_pago}-${index}`} className={`grid ${gridCols} items-center`}>
                                    <div className={`${rowClasses} font-semibold dark:text-white`}>
                                        {pago.tipo_pago_display || capitalize(pago.tipo_pago)}
                                    </div>
                                    <div className={rowClasses}>
                                        <input
                                            type="text"
                                            value={formatNumberArgentino(pago.monto || '')}
                                            onChange={(e) => {
                                                const parsed = parseNumberArgentino(e.target.value);
                                                handleChange(index, 'monto', parsed);
                                            }}
                                            onFocus={(e) => {
                                                // Quitar formato al enfocar para edición normal
                                                e.target.value = (pago.monto || '').toString();
                                            }}
                                            onBlur={(e) => {
                                                // Aplicar formato al perder foco
                                                const formatted = formatNumberArgentino(pago.monto || '');
                                                e.target.value = formatted;
                                            }}
                                            className={inputClasses}
                                            placeholder="0,00"
                                        />
                                    </div>
                                    <div className={rowClasses}>
                                        <DatePicker
                                            selected={pago.fecha_pago}
                                            //onChange={(date) => handlePagoChange(index, 'fecha_pago', date, setter, pagos)}
                                            onChange={(date) => handleChange(index, 'fecha_pago', date)}
                                            dateFormat="dd/MM/yyyy"
                                            className={inputClasses}
                                            placeholderText="DD/MM/AAAA"
                                            showYearDropdown
                                            scrollableYearDropdown
                                            yearDropdownItemNumber={15}
                                        />
                                    </div>
                                    <div className={rowClasses}>
                                        <input
                                            type="text"
                                            value={pago.nro_instruccion || ''}
                                            onChange={(e) => handleChange(index, 'nro_instruccion', e.target.value)}
                                            //onChange={(e) => handlePagoChange(index, 'nro_instruccion', e.target.value, setter, pagos)}
                                            className={inputClasses}
                                            placeholder="N° de instrucción"
                                        />
                                    </div>
                                    <div className={rowClasses}>
                                        <DatePicker
                                            selected={pago.fecha_certificacion}
                                            //onChange={(date) => handlePagoChange(index, 'fecha_certificacion', date, setter, pagos)}
                                            onChange={(date) => handleChange(index, 'fecha_certificacion', date)}
                                            dateFormat="dd/MM/yyyy"
                                            className={inputClasses}
                                            placeholderText="DD/MM/AAAA"
                                            showYearDropdown
                                            scrollableYearDropdown
                                            yearDropdownItemNumber={15}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        } else if (areaResponsable === 'ÁREA DE PROYECTOS') {
            const gridCols = 'grid-cols-7';
            
            // Verificar si hay algún expediente con objeto_o 'Rendición'
            const tieneRendicion = array_obras_expediente?.some(exp => exp.objeto_o === 'Rendición');
            console.log('Tiene rendición (PROYECTOS):', tieneRendicion);
            console.log('Pagos a renderizar (PROYECTOS):', arrayPagosProyectos);//arrayPagosProyectosValue

            // Si no hay expediente con 'Rendición', mostrar mensaje
            if (!tieneRendicion) {
                return (
                    <div className="mt-4 p-4 bg-red-50 dark:bg-red-900/20 rounded-md border border-red-200 dark:border-red-800">
                        <h3 className="text-lg font-semibold mb-2 dark:text-white">Formulario de Pagos (Nuevo)</h3>
                        <p className="text-red-700 dark:text-red-300">
                            {`⚠️ No se puede mostrar el formulario de pagos porque no hay un expediente con objeto 'Rendición'.`}
                        </p>
                    </div>
                );
            }

            // Si hay expediente con 'Rendición', mostrar el formulario de pagos
            return (
                <div className="mt-4 overflow-x-auto">
                    <h3 className="text-lg font-semibold mb-2 dark:text-white">Formulario de Pagos (Nuevo) - PROYECTOS</h3>
                    <div className="w-full">
                        {/* Header */}
                        <div className={`grid ${gridCols} text-sm lg:text-base`}>
                            <div className={headerClasses}>Pago</div>
                            <div className={headerClasses}>Porcentaje pago</div>
                            <div className={headerClasses}>Monto</div>
                            <div className={headerClasses}>Fecha de Pago</div>
                            <div className={headerClasses}>Nro. Instrucción</div>
                            <div className={headerClasses}>Avance de Obra (%)</div>
                            <div className={headerClasses}>Fecha Certificación</div>
                        </div>

                        {/* Rows */}
                        {generarArrayPruebasProyectos().map((pago, index) => {
                            console.log('Procesando pago (PROYECTOS):', pago);
                            
                            // Omitir el pago de tipo 'adenda' si no hay un expediente con objeto_o 'Adenda'
                            if (pago.tipo_pago === 'adenda' && !array_obras_expediente?.some(exp => exp.objeto_o === 'Adenda')) {
                                console.log('Omitiendo pago de adenda (PROYECTOS)');
                                return null;
                            }
                            
                            return (
                                <div key={`${pago.tipo_pago}-${index}`} className={`grid ${gridCols} items-center`}>
                                    <div className={`${rowClasses} font-semibold dark:text-white`}>
                                        {pago.tipo_pago_display || pago.tipo_pago}
                                    </div>
                                    <div className={rowClasses}>
                                        {(() => {
                                            if (index === 0) {
                                                return (
                                                    <Select_simple
                                                        value={pago.porc_pago || ''}
                                                        onChange={(e) => handlePagoChangeProyectos(index, 'porc_pago', e.target.value)}
                                                        options={OPCIONES_PORCENTAJE.ANTICIPO}
                                                        placeholder="Seleccione"
                                                        isDisabled={pago.disabled}
                                                    />
                                                );
                                            }

                                            // Si no hay anticipo seleccionado
                                            if (!arrayPagosProyectos[0]?.porc_pago) {
                                                if (pago.tipo_pago === 'adenda') {
                                                    return <span key="complete-pagos" className="text-gray-400">Complete los pagos de la obra primero</span>;
                                                }
                                                return index === 2 ? (
                                                    <span key="espere-anticipo" className="text-gray-400">Se requiere el 2do pago</span>
                                                ) : (
                                                    <span key="seleccione-anticipo" className="text-gray-400">Se requiere el anticipo primero</span>
                                                );
                                            }

                                            // Si es el tercer pago
                                            if (index === 2) {
                                                // Si el anticipo es 50%, mostrar "No aplica"
                                                if (arrayPagosProyectos[0]?.porc_pago === '50') {
                                                    return <span key="no-aplica" className="text-gray-500">No aplica</span>;
                                                }
                                                
                                                // Si el anticipo es 30% pero no se ha completado el segundo pago, mostrar mensaje
                                                if (!arrayPagosProyectos[1]?.porc_pago) {
                                                    return <span key="complete-segundo" className="text-gray-400">Complete el segundo pago primero</span>;
                                                }
                                                
                                                // Si el anticipo es 30% y el segundo pago está completo, mostrar el selector
                                                return (
                                                    <Select_simple
                                                        key="tercer-pago"
                                                        value={pago.porc_pago || ''}
                                                        onChange={(e) => handlePagoChangeProyectos(index, 'porc_pago', e.target.value)}
                                                        options={OPCIONES_PORCENTAJE.TERCER_PAGO}
                                                        placeholder="Seleccione"
                                                        isDisabled={pago.disabled}
                                                    />
                                                );
                                            }

                                            // Si es un pago de adenda
                                            if (pago.tipo_pago === 'adenda') {
                                                return (
                                                    <Select_simple
                                                        key="adenda-pago"
                                                        value={pago.porc_pago || ''}
                                                        onChange={(e) => handlePagoChangeProyectos(index, 'porc_pago', e.target.value)}
                                                        options={OPCIONES_PORCENTAJE.ADENDA}
                                                        placeholder="Seleccione"
                                                        isDisabled={pago.disabled}
                                                    />
                                                );
                                            }
                                            
                                            // Para el segundo pago (índice 1)
                                            return (
                                                <Select_simple
                                                    key="segundo-pago"
                                                    value={pago.porc_pago || ''}
                                                    onChange={(e) => handlePagoChangeProyectos(index, 'porc_pago', e.target.value)}
                                                    options={
                                                        arrayPagosProyectos[0]?.porc_pago === '50' ? 
                                                            OPCIONES_PORCENTAJE.SEGUNDO_PAGO_50 : 
                                                            OPCIONES_PORCENTAJE.SEGUNDO_PAGO_30
                                                    }
                                                    placeholder="Seleccione"
                                                    isDisabled={pago.disabled}
                                                />
                                            );
                                        })()}
                                    </div>
                                    <div className={rowClasses}>
                                        <input
                                            type="text"
                                            value={formatNumberArgentino(pago.monto || '')}
                                            onChange={(e) => {
                                                const parsed = parseNumberArgentino(e.target.value);
                                                handlePagoChangeProyectos(index, 'monto', parsed);
                                            }}
                                            onFocus={(e) => {
                                                // Quitar formato al enfocar para edición normal
                                                e.target.value = (pago.monto || '').toString();
                                            }}
                                            onBlur={(e) => {
                                                // Aplicar formato al perder foco
                                                const formatted = formatNumberArgentino(pago.monto || '');
                                                e.target.value = formatted;
                                            }}
                                            className={inputClasses}
                                            placeholder="0,00"
                                        />
                                    </div>
                                    <div className={rowClasses}>
                                        <DatePicker
                                            selected={pago.fecha_pago}
                                            onChange={(date) => handlePagoChangeProyectos(index, 'fecha_pago', date)}
                                            dateFormat="dd/MM/yyyy"
                                            className={inputClasses}
                                            placeholderText="DD/MM/AAAA"
                                            showYearDropdown
                                            scrollableYearDropdown
                                            yearDropdownItemNumber={15}
                                        />
                                    </div>
                                    <div className={rowClasses}>
                                        <input
                                            type="text"
                                            value={pago.nro_instruccion || ''}
                                            onChange={(e) => handlePagoChangeProyectos(index, 'nro_instruccion', e.target.value)}
                                            className={inputClasses}
                                            placeholder="N° de instrucción"
                                        />
                                    </div>
                                    <div className={rowClasses}>
                                        <input
                                            type="number"
                                            value={pago.porc_avance_obra || ''}
                                            onChange={(e) => handlePagoChangeProyectos(index, 'porc_avance_obra', e.target.value)}
                                            className={inputClasses}
                                            placeholder="% avance"
                                            min="0"
                                            max="100"
                                        />
                                    </div>
                                    <div className={rowClasses}>
                                        <DatePicker
                                            selected={pago.fecha_certificacion}
                                            onChange={(date) => handlePagoChangeProyectos(index, 'fecha_certificacion', date)}
                                            dateFormat="dd/MM/yyyy"
                                            className={inputClasses}
                                            placeholderText="DD/MM/AAAA"
                                            showYearDropdown
                                            scrollableYearDropdown
                                            yearDropdownItemNumber={15}
                                        />
                                    </div>
                                </div>
                            );
                        })}                        
                    </div>
                </div>
            );
        }        
        console.log('=== FIN renderPagosFormularioNuevo ===');
        return null;
    };

    return (
        <div className="p-6 border rounded-lg shadow-md">            
            <div className="flex flex-row">	
                <h2 className="text-xl font-bold dark:text-white mb-2">SEGUIMIENTO DE OBRA</h2>
                <InfoButtonWithPopover infoText="EN DESARROLLO: Los cambios no impactan en el Servidor." />                              
            </div>
            
            {/* Campos principales */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <Label htmlFor="encargado_rendicion">Encargado de Rendición</Label>
                    <Select_simple
                        value={encargadoRendicion}
                        onChange={(e) => setEncargadoRendicionValue(e.target.value)}
                        options={optionsEncargadoRendicion}
                    />
                </div>
                <div>
                    <Label htmlFor="organismo_encargado">Organismo Encargado</Label>
                    <Select_simple
                        value={organismoEncargado}
                        onChange={(e) => setOrganismoEncargadoValue(e.target.value)}
                        options={optionsOrganismoEncargado}
                    />
                </div>

                {organismoEncargado === "Empresa contratista" && (
                    <>
                    <div>
                        <Label htmlFor="empresa_contratista">Empresa Contratista</Label>
                        <Input
                            id="empresa_contratista"
                            name="empresa_contratista"
                            type="text"
                            value={empresaContratista || ''}
                            onChange={(e) => setEmpresaContratistaValue(e.target.value)}                            
                        />
                    </div>
                    <div>{/* div vacio */} </div>
                    </>
                )}
                
            </div>
            {/* Campos fechas y montos */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
            <div>   
                    <Label htmlFor="fecha_inicio_obra">Fecha Inicio Obra</Label>
                    <DatePicker
                        selected={fechaInicioObra}
                        onChange={(date) => setFechaInicioObraValue(date)}
                        dateFormat="dd/MM/yyyy"
                        className="w-full p-2 border rounded"
                        placeholderText="DD/MM/AAAA"
                    />
                </div>
                <div>   
                    <Label htmlFor="fecha_fin_obra">Fecha Fin Obra</Label>
                    <DatePicker
                        selected={fechaFinObra}
                        onChange={(date) => setFechaFinObraValue(date)}
                        dateFormat="dd/MM/yyyy"
                        className="w-full p-2 border rounded"
                        placeholderText="DD/MM/AAAA"
                    />
                </div>
                <div>
                    <Label htmlFor="monto_obraC">Monto Conveniado</Label>
                    <div className="mt-1">
                        <input
                            type="text"
                            value={`$${Number(datosGenerales.monto_obra || 0).toLocaleString('es-AR')}`}
                            readOnly
                            className="w-full p-2 border rounded bg-gray-100"
                        />
                    </div>
                </div>

                {array_obras_expediente?.some(exp => exp.objeto_o === 'Adenda') && (
                    <div>
                        <Label htmlFor="monto_adenda">Monto Adenda</Label>
                        <div className="mt-1">
                            <input
                                type="text"
                                value={`$${Number(totalAdenda).toLocaleString('es-AR')}`}
                                readOnly
                                className="w-full p-2 border rounded bg-gray-100"
                            />
                        </div>
                    </div>
                )}
                
            </div>

            {/* Renderización condicional de los formularios de pago */}            
            {/*{renderPagosFormulario()}*/}
            {renderPagosFormularioNuevo()}

            {/* Observaciones */}
            <div className="mt-4">
                <Label htmlFor="observ_seguimiento_obra">Observaciones del Seguimiento de Obra</Label>
                <textarea
                    id="observ_seguimiento_obra"
                    name="observ_seguimiento_obra"
                    value={observaciones}
                    placeholder="Ingrese observaciones del seguimiento de obra"
                    maxLength="2000"
                    onChange={(e) => setObservacionesValue(e.target.value)}
                    className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700 resize-y"
                    rows="4"
                />
                <div>
                    <p align="right" className="text-sm text-gray-500" style={{ height: "5px", fontSize: "0.9em" }}>
                        Caracteres restantes: {contadorCaracteresRestantes(2000, observaciones)}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FormC_SeguimientoObra;
